<f-chart
  [view]="view"
  [xScale]="xScale"
  [yScale]="yScale"
  [yLineScale]="lineYScale"
  [animation]="animation"
  [integerYAxis]="integerYAxis"
  [fitContainer]="fitContainer"
  [lineAxisLabelText]="lineAxisLabelText"
  [truncateXAxisTicks]="truncateXAxisTicks"
  [truncateYAxisTicks]="truncateYAxisTicks"
  [rotateXAxisTicks]="rotateXAxisTicks"
  [maxXAxisTickLength]="maxXAxisTickLength"
  [maxYAxisTickLength]="maxYAxisTickLength"
  [maxYAxisTicksCount]="maxTicksCount"
  [xAxisTickFormatting]="xAxisTickFormatting"
  [yAxisTickFormatting]="yAxisTickFormatting"
  [lineAxisTickFormatting]="lineAxisTickFormatting"
  [startLineAxisDomainWithZero]="startLineAxisDomainWithZero"
  [showXAxisGridlines]="showXAxisGridlines"
  [showYAxisGridlines]="showYAxisGridlines"
  [showXAxisTicksLabels]="showXAxisTicksLabels"
  [showYAxisTicksLabels]="showYAxisTicksLabels"
  [showLineAxisTicksLabels]="showLineAxisTicksLabels"
  [xAxisTickLabelClasses]="xAxisTickLabelClasses"
  [xAxisTickLabelOffset]="xAxisTickLabelOffset"
  [showLineAxisGridlines]="showLineAxisGridlines"
  [showBarsOptionalData]="showBarsOptionalData"
  [showXAxisDomain]="showXAxisDomain"
  [showYAxisDomain]="showYAxisDomain"
  [popoverTemplate]="popoverTemplate"
  [popoverPlacement]="popoverPlacement"
  [legendOptions]="legendOptions"
  [showLegend]="showLegend"
  [leftAxisLabelText]="leftAxisLabelText"
  [labelsOffset]="labelsOffset"
  [showBorders]="showBorders"
  [showLabels]="showLabels"
  [condensedOnDesktop]="condensedOnDesktop"
  [condensedAxisOnMobile]="condensedAxisOnMobile"
  [condensedXAxisOnDesktop]="condensedXAxisOnDesktop"
  [chartPatternsTemplate]="chartPatternsTemplate"
  (dimensionsChanged)="onDimensionsChanged($event)"
>
  <ng-container *ngIf="dimensions">
    <svg:g
      f-bar-series
      [series]="data"
      [xScale]="xScale"
      [yScale]="yScale"
      [lineData]="lineData"
      [dimensions]="dimensions"
      [barClasses]="barClasses"
      [animation]="animation"
      [condensedOnDesktop]="condensedOnDesktop"
      [interactions]="interactions"
      [animationDelay]="animationDelay"
      [parentChartComponent]="chartComponent"
      [animationDuration]="animationDuration"
      [popoverPlacement]="popoverPlacement"
      [popoverOpenDelay]="popoverOpenDelay"
      [popoverCssClass]="popoverCssClass"
      [popoverTemplate]="popoverTemplate"
      [showOptionalData]="showBarsOptionalData"
      [barBubbleShowZero]="infoBubbleShowZero"
      [barBubbleTextClasses]="infoBubbleTextClasses"
      [barBubbleClasses]="infoBubbleClasses"
      [activeBarIndex]="activeBarIndex"
      [showDataLabels]="showDataLabels"
      (seriesHover)="onBarHover($event)"
      (seriesClick)="onBarClick($event)"
    />

    <svg:g
      f-line
      [data]="lineData"
      [xScale]="$any(lineXScale)"
      [yScale]="lineYScale"
      [curved]="lineCurved"
      [lineWidth]="lineWidth"
      [lineClasses]="lineClasses"
      [circleRadius]="lineCircleRadius"
      [activeDataPointId]="activeDataPointId"
      [nearestXPointer]="pointerXCoordinate"
      [animationDuration]="animationDuration"
      [animationDelay]="animationDelay"
      [animation]="animation"
    />
  </ng-container>
</f-chart>
